// extracted by mini-css-extract-plugin
export default {"container":"imagefrom_container__pj96+","imageFrom":"imagefrom_imageFrom__1tv1l","buttons":"imagefrom_buttons__Ppl4G","leftSide":"imagefrom_leftSide__NfwSW"};